import appStoreIcon from "./appStoreIcon.svg";
import bgMouseGrey from "./bgMouseGrey.svg";
import dashboardIcon from "./dashboardIcon.svg";
import doorman from "./doorman.svg";
import elevator from "./elevator.svg";
import googlePlayIcon from "./googlePlayIcon.svg";
import homeHero from "./homeHero.svg";
import homeHeroMobile from "./homeHeroMobile.svg";
import listIcon from "./listIcon.svg";
import mobileAmenities from "./mobileAmenities.svg";
import outeastIcon from "./outEastIcon.svg";
import partnershipIcon from "./partnershipIcon.svg";
import people from "./people.png";
import petFriendly from "./petFriendly.svg";
import professionalIcon from "./professionalIcon.svg";
import sellerBannerIcon from "./sellerBannerIcon.svg";
import stairs from "./stairs.png";
import view from "./view.png";

export {
  appStoreIcon,
  bgMouseGrey,
  doorman,
  elevator,
  googlePlayIcon,
  dashboardIcon,
  listIcon,
  partnershipIcon,
  professionalIcon,
  homeHero,
  homeHeroMobile,
  petFriendly,
  mobileAmenities,
  outeastIcon,
  people,
  sellerBannerIcon,
  stairs,
  view
};
